import * as types from './types';

const mutations = {
  [types.SET_SELECTED_TEMPLATES]: (state, payload) => {
    state.selectedTemplates = payload;
  },
  [types.UPDATE_SELECTED_TEMPLATES]: (state, payload) => {
    const { id, isChecked } = payload;
    if (isChecked) {
      state.selectedTemplates.splice(state.selectedTemplates.indexOf(id), 1);
    } else {
      state.selectedTemplates.push(id);
    }
  },
  [types.UPDATE_AVAILABLE_TEMPLATES]: (state, payload) => {
    state.availableTemplates = payload;
  },
  [types.CHANGE_SELECTED_CREATIVE_TEMPLATE_GROUP]: (state, payload) => {
    state.isCreativeTemplateGroupChanged = payload;
  },
  [types.SET_CREATIVES_TEMPLATES_EDITABLE_PROPERTIES]: (state, payload) => {
    const { id, properties } = payload;
    state.creativesTemplatesEditableProperties[id] = properties;
  },
};

export default mutations;
